import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ApplicationPathName } from '../contexts/constants';
import Home from '../pages/Home/Home';
import ProtectedRoute from './ProtectedRoute';
import InputList from '../pages/Input/InputList';
import ApproveList from '../pages/Approve/ApproveList';
import InvestmentList from '../pages/Investment/InvestmentList';
import ManagementList from '../pages/ManagementList/ManagementList';
import InvestmentScreeningDetail from '../pages/InvestmentScreening/InvestmentScreeningDetail';
import StatusReport from '../pages/ceas-status-report/StatusReport';
import EquipmentGroup from '../pages/MasterMaintenance/EquipmentGroup';
import EquipmentSupplier from '../pages/MasterMaintenance/EquipmentSupplier';
import InterestRateMaster from '../pages/MasterMaintenance/InterestRateMaster';
import CompanyPlant from '../pages/MasterMaintenance/CompanyPlant';
import Nationality from '../pages/MasterMaintenance/Nationality';
import Notification from '../pages/MasterMaintenance/Notification';
import AccountingOrganization from '../pages/MasterMaintenance/AccountingOrganization';
import SystemAccessSetting from '../pages/MasterMaintenance/SystemAccessSetting';
import EquipmentCategory from '../pages/MasterMaintenance/EquipmentCategory';
import ApprovalRequesterMaster from '../pages/MasterMaintenance/ApprovalRequesterMaster';
import ActiveUsers from '../pages/MasterMaintenance/ActiveUsers';
import InquireSetting from '../pages/MasterMaintenance/InquireSetting';
import AIRestrictedOrganization from '../pages/MasterMaintenance/AIRestrictedOrganization';
import CheckListMaster from '../pages/MasterMaintenance/CheckListMaster';

/**
 *
 * @param props アプリケーションコンテンツ部
 * @returns
 */
const AppContent: React.FC = (props) => {
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(true);

  // 新規投資申請画面からそれ以外の画面遷移時にsessionStorageからprojectIdを削除
  useEffect(() => {
    const currentPath = location.pathname;
    const detailPath = ApplicationPathName.InvestmentScreeningDetail.Url;
    if (currentPath !== detailPath) {
      sessionStorage.removeItem("projectId");
    }
  }, [location.pathname]);

  return (
    <Box h="calc(100vh - 64px - 16px)" w="100%" pl="16px" pr="16px">
      {isLoaded ? (
        <Routes>
          {/* TODO : ここにログイン後に遷移および表示する画面のルートを記載する。（URLとオブジェクトの紐づけもここで行う。） */}
          {/* ホーム */}
          <Route path={ApplicationPathName.Home.Url} element={<Home />} />

          {/* 投資 */}
          <Route path={ApplicationPathName.InputList.Url} element={<InputList />} />
          <Route path={ApplicationPathName.ApproveList.Url} element={<ApproveList />} />
          <Route path={ApplicationPathName.InvestmentList.Url} element={<InvestmentList />} />
          <Route path={ApplicationPathName.ManagementList.Url} element={<ManagementList />} />
          <Route path={ApplicationPathName.InvestmentScreeningDetail.Url} element={<InvestmentScreeningDetail key={location.key} />} />
          <Route path={ApplicationPathName.StatusReport.Url} element={<StatusReport />} />

          {/* マスタメンテナンス（システム利用設定の「マスタメンテナンス表示」で制御） */}
          <Route path={ApplicationPathName.EquipmentCategory.Url} element={<ProtectedRoute><EquipmentCategory /></ProtectedRoute>} />
          <Route path={ApplicationPathName.EquipmentGroup.Url} element={<ProtectedRoute><EquipmentGroup /></ProtectedRoute>} />
          <Route path={ApplicationPathName.EquipmentSupplier.Url} element={<ProtectedRoute><EquipmentSupplier /></ProtectedRoute>} />
          <Route path={ApplicationPathName.InterestRateMaster.Url} element={<ProtectedRoute><InterestRateMaster /></ProtectedRoute>} />
          <Route path={ApplicationPathName.CompanyPlant.Url} element={<ProtectedRoute><CompanyPlant /></ProtectedRoute>} />
          <Route path={ApplicationPathName.Nationality.Url} element={<ProtectedRoute><Nationality /></ProtectedRoute>} />
          <Route path={ApplicationPathName.Notification.Url} element={<ProtectedRoute><Notification /></ProtectedRoute>} />
          <Route path={ApplicationPathName.AccountingOrganization.Url} element={<ProtectedRoute><AccountingOrganization /></ProtectedRoute>} />
          <Route path={ApplicationPathName.SystemAccessSetting.Url} element={<ProtectedRoute><SystemAccessSetting /></ProtectedRoute>} />
          <Route path={ApplicationPathName.ApprovalRequesterMaster.Url} element={<ProtectedRoute><ApprovalRequesterMaster /></ProtectedRoute>} />
          <Route path={ApplicationPathName.ActiveUsers.Url} element={<ProtectedRoute><ActiveUsers /></ProtectedRoute>} />
          <Route path={ApplicationPathName.InquireSetting.Url} element={<ProtectedRoute><InquireSetting /></ProtectedRoute>} />
          <Route path={ApplicationPathName.AIRestrictedOrganization.Url} element={<ProtectedRoute><AIRestrictedOrganization /></ProtectedRoute>} />
          <Route path={ApplicationPathName.CheckListMaster.Url} element={<ProtectedRoute><CheckListMaster /></ProtectedRoute>} />

          {/* デフォルト */}
          <Route path="*" element={<Home />} />
        </Routes>
      ) : (<></>)}
    </Box>
  );
};

export default AppContent;
